import { Ruler, Hammer, CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'motion/react';

const steps = [
  {
    icon: Ruler,
    title: 'Precise Measurement',
    description: 'On-site templating of your space with laser accuracy',
  },
  {
    icon: Hammer,
    title: 'Custom Fabrication',
    description: 'Cut, polish, and temper to your exact specifications',
  },
  {
    icon: CheckCircle2,
    title: 'Professional Install',
    description: 'Licensed installers, on-time, with minimal disruption',
  },
  {
    icon: Sparkles,
    title: 'Care & Warranty',
    description: 'Maintenance guidance and 1-year labor warranty',
  },
];

export function ProcessTimeline() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold mb-4">Our Process</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            From initial consultation to flawless installation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative"
            >
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-full h-0.5 bg-gradient-to-r from-primary/30 to-transparent" />
              )}

              <div className="relative">
                {/* Icon */}
                <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 flex items-center justify-center border-2 border-primary/20">
                  <step.icon className="w-10 h-10 text-primary" />
                </div>

                {/* Step number */}
                <div className="absolute top-0 right-[calc(50%-3rem)] w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm">
                  {index + 1}
                </div>

                {/* Content */}
                <div className="text-center">
                  <h4 className="mb-2">{step.title}</h4>
                  <p className="text-sm text-muted-foreground">{step.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
